import React from "react";
import Styles from './styles.module.scss';
import logo from '../../../theme/assets/svg/lp_logo.svg';



const Logo = () => {
    return (
        <div
            className={`${Styles.logoWrap}`}
            onClick={() => {
                window.location.assign(`${process.env.REACT_APP_NEXT_URL}`);
            }}
        >
            <img src={logo} alt="Honee"/>
        </div>
    );
};

export default Logo;